import { render } from "./DrugInfo.vue?vue&type=template&id=e71bc6b6&scoped=true"
import script from "./DrugInfo.vue?vue&type=script&lang=js"
export * from "./DrugInfo.vue?vue&type=script&lang=js"

import "./DrugInfo.vue?vue&type=style&index=0&id=e71bc6b6&scoped=scoped&lang=scss"

import exportComponent from "D:\\work\\粤智康医药网\\guanwang\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e71bc6b6"]])

export default __exports__